export default __webpack_public_path__ + "static/media/Group.0c410041.png";